define('Components/CurrencySubunit/js/CurrencySubunit',['hooks'],
    function(hooks){

        return function(){
            hooks.registerHook('formatPriceModifier',function(params,callback){
                var currency = params.currency,
                    value = params.v;
                if(currency && currency.get('subunit_enable')){
                    var display_mode = currency.get('display_mode'),
                        subunit_sign = currency.get('subunit_sign'),
                        subunit_fraction = parseFloat(currency.get('subunit_fraction'));
                    switch(display_mode){
                        case 'subunit':
                            params.v = value/subunit_fraction;
                            params.sign = subunit_sign;
                            callback(params);
                            break;
                        // TODO autres formats...
                    }
                }
            });
        }

});
